module.exports = __webpack_public_path__ + "static/media/RS.70e731ee.jpg";